module.exports = __webpack_public_path__ + "img/icon-document-download.ffd49efa.svg";